var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoomPackageGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0078 85.4854V58.1012C40.0078 58.0292 40.0465 57.9628 40.1092 57.9272L52.788 50.7412C52.9213 50.6656 53.0866 50.7619 53.0866 50.9152V77.9316L40.0078 85.4854Z",
    fill: "#B4C5D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4037 99.6192C25.0672 99.4284 25.0656 98.9441 25.4008 98.751L74.3194 70.5805C74.5498 70.4478 74.8333 70.447 75.0645 70.5785L124.167 98.5131C124.503 98.7047 124.504 99.1902 124.167 99.3821L74.6914 127.575L25.4037 99.6192Z",
    fill: "#CDD9E2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6894 133.142V86.0651L15.9087 52.1079V99.3637L74.6894 133.142Z",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6895 133.142V86.0651L133.47 52.1079V83.4157V91.5844V99.3637",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6894 18.3843V65.4611L15.9087 99.4183V52.1625",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M108.111 114.389L133.471 99.364L74.691 65.4614L15.9106 99.4186L74.691 133.142C86.4409 126.39 91.6336 123.661 101.389 118.056",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7224 37.3891L15.9087 52.2244L74.6894 85.9479L133.472 52.1698L74.6894 18.2666L50.0557 33.1114",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9997 52.6665V18.4443H29",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M104.444 112.555V133.333H120",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 30.6667C22.921 30.6667 28.6667 24.921 28.6667 17.8333C28.6667 10.7457 22.921 5 15.8333 5C8.74568 5 3 10.7457 3 17.8333C3 24.921 8.74568 30.6667 15.8333 30.6667Z",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M133.167 145.556C140.255 145.556 146.001 139.81 146.001 132.722C146.001 125.635 140.255 119.889 133.167 119.889C126.08 119.889 120.334 125.635 120.334 132.722C120.334 139.81 126.08 145.556 133.167 145.556Z",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.98 11.1113H11.5552V24.5557H19.98V11.1113Z",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1562 16.29V18.945",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M139.888 126H126.444V139.444H139.888V126Z",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M130.928 126V139.444",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M135.783 126V139.444",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M130.928 135.335H135.409",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M126.445 130.107H130.926",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M135.408 130.107H139.889",
    stroke: "#1F323D",
    strokeWidth: 0.75
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M87 40.7778L101 48.6842V63.7778L87 56.0513V40.7778Z",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M108 53.7778L121 61.6842V76.7778L108 69.0512V53.7778Z",
    stroke: "#1F323D",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomPackageGrey);
export default __webpack_public_path__ + "static/media/room_package_grey.8202d916e3513464d6a3ceef4fce459e.svg";
export { ForwardRef as ReactComponent };